import React, { useState, useRef, useEffect} from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import 'react-html5-camera-photo/build/css/index.css';
import { Button } from 'react-bootstrap';
import './SingingTime.css';
import { UploadPhoto } from '../s3Func/s3Upload';
import PopUp from '../Popup/logoutPopup';
import { CloudfrontVideoFormat } from './../videos/CloudfrontVideoFormat';
import instruction from './headphone_instructions.mp3';
import AskSinging from './student_sing_prompt.mp3';
import UsingDemo from './sing_demo_voice.mp3';
import PlayorRecord from './record_or_play_instructions.mp3';
import ReactAudioPlayer from 'react-audio-player';
import countdown1 from './Countdown-1_2x.png';
import countdown2 from './Countdown-2_2x.png';
import countdown3 from './Countdown-3_2x.png';
import countdownSound from './count_down_beep.m4a';
import pauseButton from './pause_circle_icon@3x.png';
import SingingRecordPreview from '../components/World/SingingTime/components/SingingRecordReview';
import SingingPage from '../components/World/SingingTime/components/SingingPage';
import { ReactMic } from 'react-mic';


/**
 * The SingingTime section of each module allows the child to sing along with
 * the characters of the module and record their voice. This will then be used
 * in later sections such as learn and the surprise video.
 */
export default function SingingTime(props) {
  // Initialize variables to be used later.
  const [isOpen, setIsOpen] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const videoPlayer = useRef();
  const audioPlayer = useRef();
  const recordPlayer = useRef();
  const instrumentalPlayer = useRef();
  const startRecordBtn = useRef();
  const endRecordBtn = useRef();
  const [displaySingingVideo, setDisplaySingingVideo] = useState(true);
  const [displayDecision, setDisplayDecision] = useState(false);
  const [displayIntroduction, setDisplayIntroduction] = useState(false);
  const [displaySinging, setDisplaySinging] = useState(false);
  const [videoplay, setVideoPlay] = useState(false);
  const [recordFinish, setRecordFinish] = useState(false);
  const [music, setMusic] = useState('');
  const [recording, setRecording] = useState(false);
  const [recordurl, setRecordUrl] = useState('');
  const [countDown, setCountDown] = useState(null);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const recordIcon = generateImageUrl('images/Module1Images/Record-Small_3x.png')
  const playIcon = generateImageUrl('images/Module1Images/Play-small_3x.png')
  const headphoneIcon = generateImageUrl('images/Module1Images/Icon_Headphones_Blue.png')
  const musicIcon = generateImageUrl('images/Module1Images/Ico_Music.png')

  const [switchIcon, setSwitchIcon] = useState(playIcon);
  const cdSound = new Audio(countdownSound);
  const countdownList = [countdown1, countdown1, countdown2, countdown3];
  const [instrumentalSong, setInstrumentalSong] = useState(props.instrumental);

  const moduleFullName ={
    'MODULE6': 'Greeting',
    'MODULE7': 'Answering',
    'MODULE8': 'Asking',
    'MODULE9': 'Responding',
    'MODULE10': 'Closing',
    'MODULE11': 'Feelings',
    'MODULE12': 'Understanding Feelings',
    'MODULE13': 'Changing Feelings',
    'MODULE14': 'Solutions ',
    'MODULE15': 'Active Listening',
    'MODULE16': 'Manners',
    'MODULE17': 'Making Friends',
    'MODULE18': 'Getting Along',
    'MODULE19': 'Think Believe Achieve',
    'MODULE20': 'Caring',
    
  }

  useEffect(() => {
    let song = new Audio();
    song.src = props.instrumental
    setInstrumentalSong(song);
  }, []);

  const handleConfirmRecord = async () => {
    if (!props.module.reviewIcon) {
      dispatch({
        type: `${props.moduleNum}_SET_stepCompleted`,
        payload: 'singingtime',
      });
    }
    const result = await UploadPhoto(recordurl, 'userfiles', `${props.name}_play_day_music.m4a`, 'audio/m4a', login.studentid);
    if (result === 200){
      props.setDisplaySingingTime(false);
    }
    else{
      window.alert('Whoops, failed to upload. It looks like the internet connection was lost. Please try again after login.');
      window.location.reload(false);
    }

  };

  const handleCancelRecord = () => {
    setRecordUrl(null);
    setDisplaySinging(true);
    setRecordFinish(false);
  };


  // Once the user is done recording, or once enough time has passed, end the recording and prepare for
  // recording preview to be shown.
  const myCallback = () => {
    if (recording === true) {
      endRecordBtn.current.click();
    }
    videoPlayer.current.load();
    audioPlayer.current.load();
    setVideoPlay(false);
    document.getElementById('play').style.opacity = '1';
    document.getElementById('record').style.opacity = '1';
  };

  // When the record button is clicked, begin the recording and switch the buttons to reflect it.
  const startRecording = () => {
    setSwitchIcon(playIcon);
    setVideoPlay(true);
    setIsOpen(false);
    const secondsBetweenActions = 3;
    let secondsRemaining = secondsBetweenActions;
    var interval = setInterval( async () => {
      setCountDown(secondsRemaining);
      if (secondsRemaining > 0) {
        cdSound.play();
      }
      secondsRemaining--;
      if (secondsRemaining <= -1) {
        secondsRemaining = secondsBetweenActions;
        setCountDown(null);
        clearInterval(interval);
        document.getElementById('singVideo').style.display = 'block';
        videoPlayer.current.load();
        audioPlayer.current.load();
        videoPlayer.current.play();
        audioPlayer.current.play();
        startRecordBtn.current.click()
        document.getElementById('play').style.pointerEvents = 'none';
        document.getElementById('play').style.opacity = '0.5';
        document.getElementById('record').style.opacity = '0.9';
      }
    }, 1000);
  };

  // Set a timer for ms milliseconds.
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // The HTML code to create the recorder as well as several popup questions to be asked before the recording is started.
  return (
    <>
      {displaySingingVideo && (
        <CloudfrontVideoFormat
          source={props.introVideo}
          back='/unit1'
          background={props.background}
          close={props.setDisplaySingingTime}
          ended={() => {
            setDisplaySingingVideo(false);
            setDisplayDecision(true);
          }}
        />
      )}

      {displayDecision && (
        <div className='singpage'>
          <div id='btncontainer'>
            <ReactAudioPlayer src={AskSinging} autoPlay />
            <h1 className='header'>Do you want to sing?</h1>
            <Button
              className='yesnobtn'
              variant='success'
              onClick={() => {
                setDisplayDecision(false);
                setDisplayIntroduction(true);
                navigator.permissions
                  .query({ name: 'microphone' })
                  .then(({ state }) => {
                    if (state === 'granted') {
                      // console.log('permission granted');
                    } else {
                      navigator.mediaDevices.getUserMedia({
                        audio: true,
                        video: false,
                      });
                    }
                  });
              }}
            >
              Yes
            </Button>
            <br />
            <Button
              className='yesnobtn'
              variant='danger'
              onClick={() => {
                if (props.module.reviewIcon === false) {
                  dispatch({
                    type: `${props.moduleNum}_SET_stepCompleted`,
                    payload: 'singingtime',
                  });
                }
                props.setDisplaySingingTime(false);
              }}
            >
              No
            </Button>
          </div>
        </div>
      )}

      {displayIntroduction && (
        <div className='introductionpage'>
          <ReactAudioPlayer src={instruction} autoPlay />
          <h1>Day 4</h1>
          <br />
          <br />
          <br />
          <h3>
            You will be recording the social skill song. In order to have better
            quality, sing the song while using headphones.
          </h3>
          <br />
          <br />
          <br />
          <br />
          <img
            src={headphoneIcon}
            alt='headphoneIcon'
            style={{ width: '250px' }}
          />
          <footer id='nav'>
            <h2 id='back'>
              <a
                onClick={() => {
                  setDisplayIntroduction(false);
                  setDisplayDecision(true);
                }}
              >
                &#60; BACK
              </a>
            </h2>
            <h2 id='next'>
              <a
                onClick={() => {
                  setDisplayIntroduction(false);
                  setRecordFinish(false)
                  setRecording(false);
                  setMusic(props.demoMusic);
                  setDisplaySinging(true);
                  setSwitchIcon(playIcon);
                }}
              >
                NEXT &#62;
              </a>
            </h2>
          </footer>
        </div>
      )}

      {displaySinging && (
        <div id='sing'>
          {!videoplay && !isOpen && (
            <ReactAudioPlayer src={PlayorRecord} autoPlay />
          )}
          <h1 id='singingHeader'>{login.firstname}&apos;s Recording</h1>
          {!countDown && (
            <img id='singingImage' alt='singingImage' src={musicIcon} />
          )}
          {countDown && (
            <img id='singingCountdown' src={countdownList[countDown]} />
          )}
          <div id='singingIntroduction'>
            <h3>
              It&apos;s now time for {login.firstname} to record the {moduleFullName[props.moduleNum]} song.
            </h3>
            <h3>To listen to the song, press play.</h3>
            <h3>To begin recording, press record.</h3>
          </div>
          <video id='singVideo' className='record-video' ref={videoPlayer} playsinline={true}>
            <source src={props.singingVideo} type='video/mp4'></source>
            Your browser does not support the video tag.
          </video>
          <audio
            id='singVideo'
            ref={audioPlayer}
            onEnded={() => myCallback()}
          >
            <source src={music}></source>
            Your browser does not support the video tag.
          </audio>
          <div className='recorder'>
          <ReactMic
            record={recording}
            onStop={(recordedBlob) => {
              setRecordUrl(recordedBlob.blobURL);
              setDisplaySinging(false);
              setRecordFinish(true);
            }} />
          <button onClick={()=>{setRecording(true)}} ref={startRecordBtn} type="button">Start</button>
          <button onClick={()=>{setRecording(false)}} ref={endRecordBtn} type="button">Stop</button>
            {/* <ReactMediaRecorder
              audio
              render={({
                startRecording,
                stopRecording,
              }) => (
                <div>
                  <button
                    onClick={startRecording}
                    ref={startRecordBtn} 
                    style={{ opacity: 0, height: 0 }}
                  ></button>
                  <button
                    onClick={stopRecording}
                    ref={endRecordBtn}
                    style={{ opacity: 0, height: 0 }}
                  ></button>
                </div>
              )}
              onStop={(blobUrl, blob) => {
                setRecordUrl(blobUrl);
                setDisplaySinging(false);
                setRecording(false);
                setRecordFinish(true);
              }}
            /> */}
          </div>
          <div id='afterrecord'>
            <img
              id='play'
              src={switchIcon}
              alt='play'
              onClick={() => {
                document.getElementById('singVideo').style.display = 'block';
                if (videoplay === false) {
                  setVideoPlay(true);
                  videoPlayer.current.play();
                  audioPlayer.current.play();
                  setSwitchIcon(pauseButton);
                } else {
                  setVideoPlay(false);
                  videoPlayer.current.pause();
                  audioPlayer.current.pause();
                  setSwitchIcon(playIcon);
                }
              }}
            />
            <img
              id='record'
              alt='record'
              src={recordIcon}
              onClick={() => {
                if (recording === true) {
                  setIsClose(true);
                } else {
                  if (videoplay === true) {
                    setVideoPlay(false);
                    videoPlayer.current.pause();
                    audioPlayer.current.pause();
                    document.getElementById('play').style.opacity = '1';
                  }
                  setIsOpen(true);
                  document.getElementById('singVideo').style.display = 'none';
                }
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <ReactAudioPlayer src={UsingDemo} autoPlay />
                  <b id='title'>
                    Would you like to sing along with the demo voice while you
                    record?
                    <br />
                  </b>
                  <img id='countdownSinging' src={countdownList[countDown]} />
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      setMusic(props.singingMusic);
                      startRecording();
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={() => {
                      setMusic(instrumentalSong.src);
                      startRecording();
                    }}
                  >
                    NO
                  </button>
                </>
              }
            />
          )}
          {isClose && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure to stop recording? You will lose your record at
                    this point.
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={async () => {
                      if (recording === true) {
                        endRecordBtn.current.click();
                      }
                      await sleep(500)
                      setDisplayIntroduction(true);
                      setIsClose(false);
                      setVideoPlay(false);
                      setRecording(false);
                      setDisplaySinging(false);
                      setIsOpen(false);
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={() => {
                      setIsClose(false);
                    }}
                  >
                    NO
                  </button>
                </>
              }
            />
          )}
          <footer id='nav'>
            <h2 id='back'>
              <a
                onClick={async() => {
                  endRecordBtn.current.click();
                  await sleep(500);
                  setDisplayIntroduction(true);
                  setVideoPlay(false);
                  setRecording(false);
                  setDisplaySinging(false);
                  setIsOpen(false);
                }}
              >
                &#60; BACK
              </a>
            </h2>
          </footer>
        </div>
      )}

      {recordFinish && !displayIntroduction && !displayDecision && (
        <SingingPage step={'ending'} onBackClick={handleCancelRecord}>
          <SingingRecordPreview
            recordUrl={recordurl}
            audio={props.instrumentalURL}
            onConfirmRecord={handleConfirmRecord}
            onCancelRecord={handleCancelRecord}
          />
        </SingingPage>
      )}
    </>
  );
}
